const isAllowedCountry = (notAllowedCountries, originCountry) => {
    return !notAllowedCountries || (originCountry && !notAllowedCountries.includes(originCountry))
}

export {
    isAllowedCountry
}